<button
	mat-icon-button
	class="sh-visibility-toggle-button"
	[style.visibility]="visible ? 'hidden' : 'visible'"
	(click)="toggleVisibility($event)"
>
	<mat-icon [fontIcon]="visible ? 'visibility' : 'visibility_off'"> </mat-icon>
</button>
